import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const updateStaffMember = (
  language: string,
  editedUser: any,
  successCallback: Function,
  setLoading: Function
) => {
  setLoading(true);
  ApiService.put(`staff-members/${editedUser.id}`, {
    is_active: editedUser.is_active,
    is_cohort_leader: editedUser.is_cohort_leader,
    is_meeting_animator: editedUser.is_meeting_animator,
    is_program_manager: editedUser.is_program_manager,
  })
    .then(() => {
      alert(translate(language, "PAGES.STAFF_MEMBERS.EDITED.SUCCESS"));
      successCallback();
    })
    .catch((error) => {
      console.error("Error while updating staff member:", error);
      alert(translate(language, "PAGES.STAFF_MEMBERS.EDITED.ERROR"));
    })
    .finally(() => setLoading(false));
};

export const createStaffMember = (language: string, newUser: any, successCallback: Function, setLoading: Function) => {
  setLoading(true);
  ApiService.post("staff-members", {
    user_id: newUser.user,
    is_active: newUser.is_active,
    is_cohort_leader: newUser.is_cohort_leader,
    is_meeting_animator: newUser.is_meeting_animator,
    is_program_manager: newUser.is_program_manager,
  })
    .then(() => {
      alert(translate(language, "PAGES.STAFF_MEMBERS.CREATED.SUCCESS"));
      successCallback();
    })
    .catch((error) => {
      console.error("Error while creating staff member:", error);

      if (error?.data?.error?.message?.includes("already a staff member")) {
        alert(translate(language, "PAGES.STAFF_MEMBERS.CREATED.ALREADY_EXISTS"));
      } else {
        alert(translate(language, "PAGES.STAFF_MEMBERS.CREATED.ERROR"));
      }
    })
    .finally(() => setLoading(false));
};
